import React, { FunctionComponent } from 'react';
// import { useTheme } from '@mui/material/styles';
// import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import SentimentDissatisfiedIcon from '@mui/icons-material/SentimentDissatisfied';

import { Base } from './Base';

type Props = {
  activeValue: number;
  onClick: (value: number) => void;
};

export const FaceUnhappy: FunctionComponent<Props> = ({activeValue, onClick}) => {
  // const theme = useTheme();
  // const navigate = useNavigate();
  const {t, i18n} = useTranslation(['translations']);

  return (<Base
    label={t("client.models.move_moments.feeling_nothappy", "Licht ontevreden")}
    value={1}
    activeValue={activeValue}
    onClick={onClick}
    Icon={SentimentDissatisfiedIcon}
  />);
}